import ApiClient from "./apiClient";
import { QueriesApi } from "./apiTypes";



const affiliateService = {
  getDefaultConfig:() => ApiClient.get(`referral/programs/default_config`),
  getConversions:(params?: any) => ApiClient.get(`referral/transactions`, { params }),
  getConversion:(id: string) => ApiClient.get(`referral/transactions/${id}`),
  getComissions:(params?: any) => ApiClient.get(`referral/transactions`, { params }),
  getCustomers:(params?: any) => ApiClient.get(`referral/referrals`, { params }),
  getCustomer:(id: string) => ApiClient.get(`referral/referrals/${id}`),
  createRef:() => ApiClient.post(`referral/programs`),
  getRef:() => ApiClient.get(`referral/programs`),
  addToReff:(data:any) => ApiClient.post(`referral/invite`, data),
  // getBalance:() => ApiClient.get(`referrals/balance`),
  // create:() => ApiClient.get(`referrals/commissions/`),
  // getComissions:() => ApiClient.get(`referrals/commissions/`),
  addAdmitadUid:(data:any) => ApiClient.post(`partner`, data),
}

export default affiliateService